const UI = 'UI';

export const getDialog = (store) => store[UI].dialog;
